import { Menu, type MenuProps } from 'antd';
import { useMemo } from 'react';
import styled from 'styled-components';
import {
  getPlaceholderCategoryGroupMetadata,
  getPlaceholderCategoryMetadata,
  placeholderCategoryGroups,
} from './placeholderCategoryRegistry.tsx';
import {
  type PlaceholderCategory,
  type PlaceholderReference,
  placeholderCategories,
} from './types.ts';

const StyledMenu = styled(Menu)`
  .ant-menu-item-group-list {
    .ant-menu-item {
      padding-inline: 16px !important;
    }
  }

  .ant-menu-item-group:not(:first-child) .ant-menu-item-group-title {
    border-top: 1px solid ${props => props.theme.colorBorderSecondary};
  }
`;

interface Props {
  groupedReferences: Record<string, PlaceholderReference[]>;
  onSelect?: (category: PlaceholderCategory) => void;
}

export function PlaceholderCategoryMenu(props: Props) {
  const { groupedReferences, onSelect } = props;

  const menuItems: MenuProps['items'] = useMemo(() => {
    return placeholderCategoryGroups.flatMap(group => {
      const children = placeholderCategories
        .filter(
          category =>
            groupedReferences[category] &&
            getPlaceholderCategoryMetadata(category).group === group,
        )
        .map(category => {
          const { label, icon } = getPlaceholderCategoryMetadata(category);
          return { key: category, label, icon };
        });

      if (children.length === 0) return [];

      const groupMetadata = getPlaceholderCategoryGroupMetadata(group);
      return [
        {
          type: 'group',
          key: group,
          label: groupMetadata.label,
          children,
        },
      ];
    });
  }, [groupedReferences]);

  return (
    <StyledMenu
      items={menuItems}
      onClick={info => onSelect?.(info.key as PlaceholderCategory)}
    />
  );
}
